/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_5_AInputs */

const en_pc_faq_5_a = /** @type {(inputs: Pc_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet for professional daily work. The developers call it early alpha. Generative AI, some tools, deeper typography and plug-in support are still missing.`)
};

const zh_pc_faq_5_a = /** @type {(inputs: Pc_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业日常工作暂时还不行。开发者自己称其为早期 Alpha，生成式 AI、部分工具、深度排版和插件支持都还没有。`)
};

/**
* | output |
* | --- |
* | "Not yet for professional daily work. The developers call it early alpha. Generative AI, some tools, deeper typography and plug-in support are still missing." |
*
* @param {Pc_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_5_a = /** @type {((inputs?: Pc_Faq_5_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_5_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_5_a(inputs)
	return zh_pc_faq_5_a(inputs)
});
export { pc_faq_5_a as "pc.faq.5.a" }